<template>
    <div id="app" class="wrap">
        <Header />
        <router-view />
        <Footer v-if="!$store.state.is_loading" />
        <Search />
        <Cookies v-if="show_cookies" />
    </div>
</template>

<script>
import "@/assets/svg/ico.svg?sprite";

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
// import Loading from "@/components/Loading.vue";
import Cookies from "@/components/Cookies.vue";
import Search from "@/components/Search.vue";

export default {
    name: "app",

    components: {
        Header,
        Footer,
        // Loading,
        Cookies,
        Search
    },

    data() {
        return {
            show_cookies: false
        };
    },

    watch: {
        "$route.params": {
            handler(params) {
                this.updateClass(params);
                if (
                    this.$store.state.accordion_counter >= 0 &&
                    this.$store.state.accordion_counter <= 4
                ) {
                    this.$store.state.accordion_counter++;
                }

                if (this.$store.state.accordion_counter > 4) {
                    this.$store.state.accordion_counter = -1;
                    this.$store.state.open_accordion_id = -1;
                    this.$store.state.accordion_open = false;
                }
            },

            immediate: true
        }
    },

    methods: {
        updateClass(params) {
            this.$store.state.is_loading = true;
            this.$store.state.is_disabled = true;

            let body_class = "";
            if (typeof this.$route.name === "string");
            body_class = "is-init page-" + this.$route.name;
            if (typeof this.$route.meta === "string")
                body_class =
                    " page-type-" + this.$route.meta + " " + body_class;

            document.body.className = body_class;

            if (this.$store.state.disabled_scroll) {
                setTimeout(() => {
                    this.$store.state.disabled_scroll = false;
                }, 100);
            } else {
                window.scrollTo(0, 0);
            }

            this.$store.state.show_navi = false;

            if (
                typeof window.ga === "function" &&
                typeof window.ga.getAll === "function"
            ) {
                var name = "send";
                var trackers = window.ga.getAll();
                if (trackers.length !== 0) {
                    var gname = trackers[0].get("name");
                    if (gname !== "" && gname !== "t0")
                        name = gname + "." + name;
                }

                ga(name, {
                    hitType: "pageview",
                    page: location.pathname
                });
            }

            setTimeout(() => {
                this.$store.state.is_disabled = false;
            }, 1000);
        }
    },

    mounted() {
        if (window.localStorage.getItem("hide_cookies") === null)
            this.show_cookies = true;
    }
};
</script>
<style lang="scss">
@import "@/assets/sass/fonts";
@import "@/assets/sass/reset";
@import "@/assets/sass/print";

/********* Base */
$padding: 2.5rem;
$base-size: 1.8rem;

:root {
    --font: "Basel Grotesk", sans-serif;
    --page-width: 100rem;
    --base-size: #{$base-size};
    --large-size: #{$base-size * 1.5};
    --tiny-size: #{$base-size * 0.58};
    --small-size: #{$base-size * 0.71};
    --title-size: #{$base-size * 2.5};
    --letter-spacing: 0rem;

    --margin: 8.5rem;
    --border: 0.15rem;

    --padding-25: calc(#{$padding} / 4);
    --padding-50: calc(#{$padding} / 2);
    --padding-75: calc(#{$padding} / 1.333333);
    --padding: #{$padding};
    --padding-x2: #{$padding * 2};
    --padding-x3: #{$padding * 3};
    --padding-x4: #{$padding * 4};
    --padding-x5: #{$padding * 5};
    --padding-x6: #{$padding * 6};

    --font-color: #000;
    --bg-color: #fff;
    --grey: #b7b7b7;
    --orange: rgb(136, 45, 23);
    --blue: rgb(0, 0, 255);
    --white: #fff;
    --black: #000;
}

input,
text,
keygen,
select,
button,
meter,
progress {
    font-family: var(--font);
}

/********* Links */
a,
a:visited,
a:active {
    color: var(--font-color);
    outline: none;
    text-decoration: none;
    // transition: color .2s;
}

a:hover {
    text-decoration: none;
    // color: var(--grey);

    img {
        // filter: brightness(.85);
    }
}

input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px white inset;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-weight: normal;
}

strong,
b {
    font-weight: 400;
}

i,
em {
    font-style: italic;
}

html {
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-size: 1vw;
    background-color: var(--white);
}

// .hidebg {
//     position: fixed;
//     left: 0;
//     top: 0;
//     height: 100%;
//     width: 100%;
//     z-index: 999999;
// }

// @media only screen and (min-width: 1270px) {
//     html {
//         font-size: 13px;
//     }
// }

// @media only screen and (min-width: 1500px) {
//     html {
//         font-size: 15px;
//     }
// }

// @media only screen and (min-width: 1600px) {
//     html {
//         font-size: 15px;
//     }
// }

html body {
    font-family: var(--font);
    color: var(--font-color);

    /* Font smoothing */
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: greyscale;
    font-size: var(--base-size);
    min-height: 100vh;
    line-height: 1.2;
    background-color: var(--theme-color-bg);

    // &.loading,
    // &.loading * {
    //     cursor: none;
    // }
}

i,
em {
    font-style: normal;
}

.fade-enter-active,
.fade-leave-active {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.wrap {
    min-height: calc(100vh - 8rem);
    display: grid;
    grid-template-rows: 1fr auto;
    grid-template-columns: 100%;
    padding-bottom: 8rem;
}

.page-inner {
    width: 100%;
    box-sizing: border-box;
    max-width: var(--page-width);
    margin-left: auto;
    margin-right: auto;
    padding: 0 var(--margin);
}

html.black-mode {
    &:root {
        --font-color: #fff;
        --bg-color: #000;
        // --grey: rgb(183,183,183);
        --orange: rgb(136, 45, 23);
        --blue: rgb(136, 45, 23);
        --white: #000;
        --black: #fff;
        --grey: #757575;
    }
}

.desktop-only {
    display: inline-block;
}

.mobile-only {
    display: none;
}

@media only screen and (max-width: 767px) {
    $padding: 4.5rem;
    $base-size-2: 4.5rem;

    :root {
        --page-width: 100%;
        --base-size: #{$base-size-2};
        --large-size: #{$base-size-2 * 1.29};
        --tiny-size: #{$base-size-2 * 0.71};
        --small-size: #{$base-size-2 * 0.71};
        --title-size: #{$base-size-2 * 1.87};
        --letter-spacing: 0rem;

        --margin: 4.5rem;
        --border: 0.5rem;

        --padding-25: calc(#{$padding} / 4);
        --padding-50: calc(#{$padding} / 2);
        --padding-75: calc(#{$padding} / 1.333333);
        --padding: #{$padding};
        --padding-x2: #{$padding * 2};
        --padding-x3: #{$padding * 3};
        --padding-x4: #{$padding * 4};
        --padding-x5: #{$padding * 5};
        --padding-x6: #{$padding * 6};
    }

    #app {
        padding: 12rem 0 0;
        width: 100%;
        overflow: hidden;
    }

    .page-inner {
        width: 100%;
        max-width: unset;
        padding-top: 0;

        & > .ui-enter {
            padding: 0;
            margin-top: 0;

            a:not(.post-item) {
                text-decoration: underline;
                &:hover {
                    text-decoration: none;
                }
            }
        }
    }

    .desktop-only {
        display: none;
    }

    .mobile-only {
        display: inline-block;
    }
}
</style>
